import { createSelector } from "@reduxjs/toolkit";
import { IState } from "../../Model/State/IState";
import { selectSelectedOrActiveProjectIds, selectSelectedOrActiveProjects } from "./Projects";
import { selectIsDetailsOpen } from "./UI";

export function selectShowCloneDialog(state: IState): boolean {
  return state.clone.showDialog;
}

export function selectCloneIndexRaw(state: IState): number {
  return state.clone.cloneIndex;
}

export const selectCloneIndex = createSelector(
  (state: IState) => selectIsDetailsOpen(state),
  (state: IState) => state.clone.cloneIndex,
  (isDetailsOpen, cloneIndex) => (isDetailsOpen ? 0 : cloneIndex)
);

export const selectCloningProject = createSelector(
  (state: IState) => selectCloneIndex(state),
  (state: IState) => selectSelectedOrActiveProjects(state),
  (cloneIndex, selectedProjects) => selectedProjects[cloneIndex]
);

export const selectCloningProjectId = createSelector(
  (state: IState) => selectCloneIndex(state),
  (state: IState) => selectSelectedOrActiveProjectIds(state),
  (cloneIndex, selectedProjectIds) => selectedProjectIds[cloneIndex]
);
